/* tslint:disable */

export enum GuidelineState {
  InProgress = 0,
  InReview = 1,
  Approved = 2,
  Published = 3,
  Inactive = 4,
}
